export const notificationDelay = 5 * 1000
export const pageSize = 10
